import * as React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const ExcelIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg role="presentation" focusable="false" viewBox="0 0 28 28" className={classes.svg}>
      <path d="M18 3H9C8.448 3 8 3.448 8 4V9L18 14L22 15.5L26 14V9L18 3Z" fill="#21A366" />
      <path d="M8 14H18V9.021H8V14Z" fill="#107C41" />
      <path d="M26 4V9H18V3H25C25.55 3 26 3.45 26 4Z" fill="#33C481" />
      <path
        d="M18 14H8V19.019V19.061V24C8 24.552 8.448 25 9 25H25C25.552 25 26 24.552 26 24V19L18 14Z"
        fill="#185C37"
      />
      <path
        opacity="0.5"
        d="M15.8332 8H8.00024V22H15.6042C16.3122 22 17.0002 21.288 17.0002 20.646V9.167C17.0002 8.525 16.4752 8 15.8332 8Z"
        fill="black"
      />
      <path
        d="M14.833 20.9995H3.167C2.523 20.9995 2 20.4775 2 19.8325V8.1665C2 7.5225 2.523 7.0005 3.167 7.0005H14.833C15.477 7.0005 16 7.5225 16 8.1665V19.8325C16 20.4775 15.477 20.9995 14.833 20.9995Z"
        fill="#107C41"
      />
      <path
        d="M5.42676 18L8.01576 13.989L5.64476 10H7.55276L8.84676 12.55C8.96576 12.791 9.04776 12.972 9.09176 13.091H9.10876C9.19476 12.897 9.28376 12.709 9.37676 12.527L10.7598 10H12.5118L10.0798 13.967L12.5728 18H10.7098L9.21476 15.199C9.15176 15.095 9.09176 14.971 9.03576 14.826H9.01376C8.98776 14.915 8.93076 15.036 8.84076 15.188L7.30176 18H5.42676Z"
        fill="white"
      />
      <path d="M18 19H26V14H18V19Z" fill="#107C41" />
    </svg>
  ),
  displayName: 'ExcelIcon',
});
